import { createInitialEntities } from "../../utils/createInitialEntities";
import { TAppPopovers, TPopoverIds } from "../types";

export const POPOVER_IDS = [
  "assistant_settings_popover",
  "header_service_manager_popover",
  "publish_link_popover",
  "sidebar_search_popover",
  "user_account_popover",
] as const;

export const APP_POPOVERS: TAppPopovers = createInitialEntities(
  POPOVER_IDS,
  (id: TPopoverIds) => ({
    id,
    info: null,
    isOpen: false,
    position: null,
    subtype: "",
  }),
);
